import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, split } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { TokenRefreshLink } from "apollo-link-token-refresh";
import { persistCache } from "apollo3-cache-persist";
import JwtDecode from "jwt-decode";
import { SubscriptionClient } from "subscriptions-transport-ws";

import config from "config";
import { getDeviceToken, setDeviceToken, subscribeToDeviceToken } from "utility/deviceToken";

import { observerLink } from "./observerLink";

export const cache = new InMemoryCache();
// await before instantiating ApolloClient, else queries might run before the cache is persisted

(async () => {
	await persistCache({
		cache,
		storage: window.localStorage
	});
})();

const httpLink = new HttpLink({
	// credentials: "include",
	uri: config.apiUrl
});

const subscriptionClient = new SubscriptionClient(config.wsApiUrl, {
	reconnect: true,
	connectionParams: () => getDeviceToken()
});

subscribeToDeviceToken(() => subscriptionClient.close(true, true));

const wsLink = new WebSocketLink(subscriptionClient);
const retryLink = new RetryLink();
// TOKEN REFRESH
const tokenRefreshLink = new TokenRefreshLink({
	accessTokenField: "at",
	isTokenValidOrUndefined: () => {
		const token = getDeviceToken();
		if (!token) {
			return true;
		}
		try {
			/// check if expired
			const { exp } = JwtDecode(token);
			if (Date.now() >= exp * 1000) {
				return false;
			} else {
				return true;
			}
		} catch {
			return false;
		}
	},
	fetchAccessToken: () => {
		return fetch("/refresh_token", {
			method: "POST",
			credentials: "include"
		});
	},
	handleFetch: accessToken => {
		setDeviceToken(accessToken);
	},
	handleError: err => {
		if (err) {
			console.error("Token err", err);
			// TODO:  Do something
		}
	}
});

const errorHandler = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		// EventLogging.captureException(graphQLErrors);
		console.error("graphQLErrors in apolloClient: ", graphQLErrors);
		//TODO: Do something useful
		// sendToLoggingService(graphQLErrors);
		graphQLErrors.map(({ message, locations, path }) => {
			console.log("GQL Err message", message);
			if (message === "Not authorized") {
				//redirect?
				// navigate("/logout");
			} else {
			}
		});
	}
	if (networkError) {
		console.error("NetworkError in apolloClient: ", networkError);
		// EventLogging.captureException(networkError);
		// logoutUser();
		//TODO: Do something useful
	}
});

const requestLink = ApolloLink.from([
	// tokenRefreshLink, //TODO:  fix; apollo-link-token-refresh is not working on apollo client v3
	observerLink,
	retryLink,
	errorHandler,
	// withClientState({
	// 	defaults: {
	// 		isConnected: true
	// 	},
	// 	resolvers: {
	// 		Mutation: {
	// 			updateNetworkStatus: (_, { isConnected }, { cache }) => {
	// 				cache.writeData({ data: { isConnected } });
	// 				return null;
	// 			}
	// 		}
	// 	},
	// 	cache
	// }),
	split(
		({ query }) => {
			const definition = getMainDefinition(query);
			return definition.kind === "OperationDefinition" && definition.operation === "subscription";
		},
		wsLink,
		httpLink
	)
]);

const apolloClient = new ApolloClient({
	cache,
	// link: httpLink //requestLink
	link: requestLink
});

export default apolloClient;
